
export function basename(path) {
    return path.replace(/.*\//, '');  // e.g. /folder/subfolder/file.ex ==> file.ext
}

export function dirname(path) {
    return path.match(/.*\//); // // e.g. /folder/subfolder/file.ext ==> /folder/subfolder/
}

export function appendVenueLoc(locationName,venueName) {
    let loc = locationName.toLowerCase(); 
    let venue = venueName.toLowerCase();
    let locName = ''; 
    if (loc.indexOf(venue) > -1) locName = locationName; 
    else locName = venueName+', '+locationName; 
    return (locName); 
}  

export function converDateToLocal(dateValue,offSetValue,formatType,dateSeparator) {
    if(!dateValue) return dateValue; 
    let sepVar = '/';
    if(dateSeparator) sepVar = dateSeparator;
    let newDateVal = new Date(dateValue);  // 2020-07-30T09:30:00Z
    let utc = newDateVal.getTime() + (newDateVal.getTimezoneOffset() * 60000);
    let arrT = (offSetValue && offSetValue.length) ? String(offSetValue.replace("+","")).split(':'): []; 
    let hours = (parseInt(arrT[0],10)) ? parseInt(arrT[0],10) : 0; 
    let minutes = (parseInt(arrT[1],10)) ? parseInt(arrT[1],10) : 0; // TO HANDLE GMT - 00
    let timeVal = (hours*60*60*1000) + (minutes*60*1000)
    let timeVar = new Date(utc + timeVal);
    let utcDate = new Date(utc);

    
    let yyyy = timeVar.getFullYear();
    let mm = timeVar.getMonth()+1;
    if(Number(mm) < 10) mm = '0'+mm;
    let dd = timeVar.getDate();
    if(Number(dd) < 10) dd = '0'+dd;
    let hh = timeVar.getHours();
    if(Number(hh) < 10) hh = '0'+hh;
    let ii = timeVar.getMinutes();
    if(Number(ii) < 10) ii = '0'+ii;
    let ss = timeVar.getSeconds();
    if(Number(ss) < 10) ss = '0'+ss;

    if(formatType==='ddmmyyyyhhmm') return(dd+sepVar+mm+sepVar+yyyy+' '+hh+':'+ii); 
    else if(formatType==='yyyymmddThhmmss') return(yyyy+sepVar+mm+sepVar+dd+'T'+hh+':'+ii+':'+ss); 
    else if(formatType==='yyyymmdd') return(yyyy+sepVar+mm+sepVar+dd); 
    else if(formatType==='ddmmyyyy') return(dd+sepVar+mm+sepVar+yyyy); 
    else if(formatType==='hhmmss') return(hh+':'+ii+':'+ss); 
    else if(formatType==='hhmm') return(hh+':'+ii); 
    else if(formatType==='dayddmmyyyy') {
        var dayNames = [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        var dName =  dayNames[timeVar.getDay()]; 
        return(dName+', '+dd+sepVar+mm+sepVar+yyyy); 
    }
    else if(formatType==='dayMondd') {
        var dayNames = [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
        var mName =  monthNames[timeVar.getMonth()];  
        var dName =  dayNames[timeVar.getDay()];    
        return(dName+', '+mName+' '+dd); 
    }else if(formatType==='MonthdayYear') {
        var dayNames = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
        var mName =  monthNames[timeVar.getMonth()];  
        var dName =  dayNames[timeVar.getDay()];    
        return(mName+' '+dd+', '+yyyy); 
    }else if(formatType==='day') {
        var dayNames = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        var dName =  dayNames[timeVar.getDay()];    
        return(dName);
    }else if(formatType==='dateObj') {
        return timeVar;
    }else if(formatType==='dayMonthdd') {
            var dayNames = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
            var mName =  monthNames[timeVar.getMonth()];  
            var dName =  dayNames[timeVar.getDay()];    
            return(dName+', '+mName+' '+dd); 
    }else if(formatType==='Monthdd') {
        var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
        var mName =  monthNames[timeVar.getMonth()];  
        return(mName+sepVar+dd); 
}
    else return(dd+sepVar+mm+sepVar+yyyy+' '+hh+':'+ii+':'+ss);
}

export function convertDecimalToHHMM(time) {
    var hrs = parseInt(Number(time),10) < 10 ? '0'+parseInt(Number(time),10) : parseInt(Number(time),10);
    var min = Math.round((Number(time)-hrs) * 60)< 10 ? '0'+Math.round((Number(time)-hrs) * 60) : Math.round((Number(time)-hrs) * 60);
    return hrs+':'+min; // +':00';
}

export function convertHHMMToDecimal(time) {
    time = time.split(':');
    return (parseFloat(parseInt(time[0], 10) + parseInt(time[1], 10)/60)).toFixed(6);
}

export function decimalTwo(numVal) { 
    let arrTmp = [];  
    let numStr = numVal; 
    arrTmp = numVal.split('.'); 
    if(arrTmp.length > 1) {
        if(arrTmp[1].length > 2) arrTmp[1] = arrTmp[1].substring(0,2); 
        numStr = arrTmp[0]+'.'+arrTmp[1]; 
    }
    return numStr;
}

export function getPrevDate(numDays,sepVal) {
    let dtNum = numDays ? Number(numDays) : 0; 
    let sep = sepVal ? sepVal : '/'; 
    let d = new Date(new Date().getTime() - (dtNum * 24 * 60 * 60 * 1000)); 
    let dd = Number(d.getDate()) >= 10 ? d.getDate() : '0'+d.getDate(); 
    let mm = Number((d.getMonth()+1)) >= 10 ? (d.getMonth()+1) : '0'+(d.getMonth()+1); 
    return dd+sep+mm+sep+d.getFullYear();  
}

export function converDateToLocalWithOutOffset(dateValue,offSetValue,formatType,dateSeparator) {
    if(!dateValue) return dateValue; 
    let sepVar = '/';
    if(dateSeparator) sepVar = dateSeparator;
    let newDateVal = new Date(dateValue);  // 2020-07-30T09:30:00Z
    let utc = newDateVal.getTime() + (newDateVal.getTimezoneOffset() * 60000);
    let arrT = (offSetValue && offSetValue.length) ? String(offSetValue.replace("+","")).split(':'): []; 
    let hours = (parseInt(arrT[0],10)) ? parseInt(arrT[0],10) : 0; 
    let minutes = (parseInt(arrT[1],10)) ? parseInt(arrT[1],10) : 0; // TO HANDLE GMT - 00
    let timeVal = (hours*60*60*1000) + (minutes*60*1000)
    let timeVar = new Date(utc + timeVal);
    let utcDate = new Date(utc);
    if(offSetValue === ""){
        timeVar = dateValue;
    }

    let yyyy = timeVar.getFullYear();
    let mm = timeVar.getMonth()+1;
    if(Number(mm) < 10) mm = '0'+mm;
    let dd = timeVar.getDate();
    if(Number(dd) < 10) dd = '0'+dd;
    let hh = timeVar.getHours();
    if(Number(hh) < 10) hh = '0'+hh;
    let ii = timeVar.getMinutes();
    if(Number(ii) < 10) ii = '0'+ii;
    let ss = timeVar.getSeconds();
    if(Number(ss) < 10) ss = '0'+ss;

    if(formatType==='ddmmyyyyhhmm') return(dd+sepVar+mm+sepVar+yyyy+' '+hh+':'+ii); 
    else if(formatType==='yyyymmddThhmmss') return(yyyy+sepVar+mm+sepVar+dd+'T'+hh+':'+ii+':'+ss); 
    else if(formatType==='yyyymmdd') return(yyyy+sepVar+mm+sepVar+dd); 
    else if(formatType==='ddmmyyyy') return(dd+sepVar+mm+sepVar+yyyy); 
    else if(formatType==='hhmmss') return(hh+':'+ii+':'+ss); 
    else if(formatType==='hhmm') return(hh+':'+ii); 
    else if(formatType==='dayMondd') {
        var dayNames = [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
        var mName =  monthNames[timeVar.getMonth()];  
        var dName =  dayNames[timeVar.getDay()];    
        return(dName+', '+mName+' '+dd); 
    }else if(formatType==='MonthdayYear') {
        var dayNames = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
        var mName =  monthNames[timeVar.getMonth()];  
        var dName =  dayNames[timeVar.getDay()];    
        return(mName+' '+dd+', '+yyyy); 
    }else if(formatType==='day') {
        var dayNames = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        var dName =  dayNames[timeVar.getDay()];    
        return(dName);
    }else if(formatType==='dateObj') {
        return timeVar;
    }else if(formatType==='dayMonthdd') {
            var dayNames = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
            var mName =  monthNames[timeVar.getMonth()];  
            var dName =  dayNames[timeVar.getDay()];    
            return(dName+', '+mName+' '+dd); 
    }
    else return(dd+sepVar+mm+sepVar+yyyy+' '+hh+':'+ii+':'+ss);
}

export function getSortClass (needSort,sortType) { // ADDED ON 09AUG2021
    return (needSort && (sortType==''||sortType=='asc')) ? ' la la-sort-up ' : (needSort && (sortType=='-'||sortType=='desc')) ? ' la la-sort-down ' : ' la la-sort '; 
}

export function checkBrowserAppleSafari () {
    var sBrowser, sUsrAg = navigator.userAgent;

    if (sUsrAg.indexOf("Firefox") > -1) {
        sBrowser = "Mozilla Firefox";
        // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
        sBrowser = "Samsung Internet";
        // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
        sBrowser = "Opera";
        // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (sUsrAg.indexOf("Trident") > -1) {
        sBrowser = "Microsoft Internet Explorer";
        // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (sUsrAg.indexOf("Edge") > -1) {
        sBrowser = "Microsoft Edge";
        // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    } else if (sUsrAg.indexOf("Chrome") > -1) {
        sBrowser = "Google Chrome or Chromium";
        // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (sUsrAg.indexOf("Safari") > -1) {
        sBrowser = 'safari'; // "Apple Safari";
        // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
        sBrowser = "unknown";
    }
    //console.log("You are using: " + sBrowser);
    return(sBrowser=='safari' ? true : false); 
}
